import { render, staticRenderFns } from "./Spanco.vue?vue&type=template&id=3d39c496&"
import script from "./Spanco.vue?vue&type=script&lang=js&"
export * from "./Spanco.vue?vue&type=script&lang=js&"
import style0 from "./Spanco.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports